<!-- src/components/StraitJumpNav.svelte
     跳轉按鈕。文字 hint/title 從 JSON 讀,海峽清單從 straitScenes.js 讀
     v10:從 v9 的「step-${id}」改成「在 ContentDataStore 裡找該海峽的第一個元素的 DOM」 -->
<script>
  import { navigableStraits } from '../data/straitScenes.js'
  import ContentDataStore from '../stores/ContentDataStore.js'

  $: jumpNav = $ContentDataStore?.jump_nav || {}

  function jumpTo(sceneId) {
    // v10 跳轉邏輯:找 .scene-wrap section 內,該海峽第一個觸發盒的 DOM
    // 海峽的內容在 scroll_<sceneId> 陣列裡,渲染順序按 sceneOrder
    // 我們可以直接捲到「scene-wrap」section 然後加上偏移(該海峽前面海峽的觸發盒高度總和)
    // 簡單版:直接捲到 scene-wrap 的開頭,讓讀者自己滾到對應海峽
    // (這個簡單版適用於開發階段;生產要更精準的話可以再優化)
    const target = document.querySelector(`#scroll-anchor-${sceneId}`)
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      return
    }
    // fallback:直接捲到 scrollytelling 區塊開頭
    const fallback = document.querySelector('.scene-wrap')
    if (fallback) fallback.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
</script>

<section class="jump-nav">
  {#if jumpNav.hint}<div class="jump-nav-hint">{jumpNav.hint}</div>{/if}
  {#if jumpNav.title}<div class="jump-nav-title">{jumpNav.title}</div>{/if}
  <div class="jump-nav-grid">
    {#each navigableStraits as strait, i}
      <button class="jump-btn" on:click={() => jumpTo(strait.id)}>
        <span class="idx">{String(i + 1).padStart(2, '0')}</span>
        {strait.label}
      </button>
    {/each}
  </div>
</section>

<style>
  .jump-nav {
    max-width: 780px;
    margin: 4rem auto 2rem;
    padding: 2.5rem 2rem 3.5rem;
    border-top: 1px solid #d0cdc6;
    border-bottom: 1px solid #d0cdc6;
    font-family: 'Noto Sans TC', sans-serif;
  }
  .jump-nav-hint {
    text-align: center;
    color: var(--color-accent, #d44545);
    font-size: 0.85rem;
    letter-spacing: 0.4em;
    margin-bottom: 1rem;
    font-weight: 600;
    text-transform: uppercase;
  }
  .jump-nav-title {
    text-align: center;
    color: var(--color-text, #222222);
    font-size: 1.3rem;
    letter-spacing: 0.15em;
    margin-bottom: 2rem;
    font-weight: 600;
  }
  .jump-nav-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 0.75rem;
  }
  .jump-btn {
    background: transparent;
    border: 1px solid #c8c4ba;
    color: var(--color-text, #222222);
    padding: 0.9rem 1.2rem;
    font-family: inherit;
    font-size: 0.95rem;
    letter-spacing: 0.08em;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  .jump-btn:hover {
    background: var(--color-accent, #d44545);
    color: #ffffff;
    border-color: var(--color-accent, #d44545);
  }
  .jump-btn .idx {
    display: inline-block; width: 1.5em;
    color: var(--color-text-dim, #777777); font-size: 0.85em;
    margin-right: 0.3em;
  }
  .jump-btn:hover .idx { color: #ffffff; }
</style>
